import React from "react";
import { FeedCount, FeedCountProps } from "web/react/components/feed-count/feed-count";
import { FeedSort, FeedSortProps } from "web/react/components/feed-sort/feed-sort";
import styles from "./feed-count-and-sort.css";

interface FeedCountAndSortProps extends FeedCountProps, FeedSortProps {}

export function FeedCountAndSort(props: FeedCountAndSortProps): JSX.Element {
    return (
        <div className={styles.box}>
            <FeedCount productCount={props.productCount} retailerCount={props.retailerCount} />
            <FeedSort sortOptions={props.sortOptions} />
        </div>
    );
}

export default FeedCountAndSort;
